// extracted by mini-css-extract-plugin
export default {"about":"about-zqB_","avatar":"avatar-YARG","name":"name-DWeA","email":"email-_fEw"};